const DataServices: React.FC = () => {
  return <></>;
};

export default DataServices;
